<script>
  export default {
    name: "ToggleDiv",
    data: function () {
      return {
        isShow1: false,
      };
    },

    props: {
      msg: String,
    },
  };
</script>


<template>
<h1>Audiosignale</h1>

    <div align="center">
      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;">
        <img class="card-img-top pb-3" src="@/assets/spec-analyse-abl.jpg" alt="Card image cap">
        <h5 class="card-title">Über dieses Modul</h5>
        <div class="card-body">
        In diesem Modul werden Signale und Audiosignale mit allen in der VL vorgestellten Prinzipien, Wandlern und Vorgehensweisen erneut vorgestellt.
        <br>
        <br>
        Insbesondere werden in diesem Modul Audiosignale beispielhaft durch eine Fouriertransformation in ihren Grundton und entsprechende Obertöne zerlegt.
        Das Resultat wird mit zwei verschiedenen Wellenformen, die in der realen Welt häufig Anwendung finden, mit einer Aufnahme eines gesprochenen
        Vokals und der Aufnahme eines Instruments visuell und auditiv wahrnehmbar dargestellt.
        </div>

        
        
      </div>
    </div>


</template>

